import React, { Component } from 'react'
import { withRouter } from 'react-router'

import UserMenu from '../UserMenu'
import { Phone, GirlColor, BoyColor } from '../../Icons'
import { Wrap, Item, IconContainer } from './styles'

class IconNav extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  handleSwitchBranch() {
    this.props.onSwitchBranch()
  }

  openPopup() {
    this.props.onClickContact()
  }

  render() {
    return (
      <Wrap>
        <Item onClick={this.openPopup.bind(this)}>
          <IconContainer small>
            <Phone size="" />
          </IconContainer>
        </Item>

        <Item active={this.props.userMenuActive} onClick={this.handleClick.bind(this)}>
          <IconContainer>{this.props.gender === 'MALE' ? <BoyColor size="" /> : <GirlColor size="" />}</IconContainer>

          <UserMenu
            permissions={this.props.permissions}
            branchName={this.props.branchName}
            onClickLink={this.handleClick.bind(this)}
            onSwitchBranch={this.handleSwitchBranch.bind(this)}
            handleLogout={this.props.handleLogout}
          />
        </Item>
      </Wrap>
    )
  }
}

export default withRouter(IconNav)



// WEBPACK FOOTER //
// ./src/components/Header/IconNav/index.js